import { useTranslation } from 'react-i18next';

import { EmptyState, Flex } from '@kognitos/lattice';
import { AccessDenied } from '@/shared/components';
import { checkIsAccessDeniedError } from '@/shared/utils/error-handler';

interface IErrorScreenProps {
  error?: Error | null;
}

/**
 * Error component displayed when backend verification fails
 */
export const ErrorScreen = ({ error }: IErrorScreenProps) => {
  const { t } = useTranslation('common');

  const isAccessDeniedError = checkIsAccessDeniedError(error);

  return (
    <Flex justify="center" align="center" width="full" height="screen">
      {/* Added this div so the empty state won't take full width of the screen */}
      <div>
        {isAccessDeniedError ? (
          <AccessDenied className="max-w-md" />
        ) : (
          <EmptyState
            title={t('common.error.title')}
            description={t('common.error.subtitle')}
            actionLabel={t('common.action.reload')}
            actionSize="lg"
            actionIcon="RefreshCw"
            onAction={() => window.location.reload()}
          />
        )}
      </div>
    </Flex>
  );
};
